import { render, staticRenderFns } from "./name-telephone-field.vue?vue&type=template&id=36499e79&scoped=true"
import script from "./name-telephone-field.vue?vue&type=script&lang=js"
export * from "./name-telephone-field.vue?vue&type=script&lang=js"
import style0 from "./name-telephone-field.vue?vue&type=style&index=0&id=36499e79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36499e79",
  null
  
)

export default component.exports